import PrivateRoutes from 'routes/PrivateRoutes';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const PatientPortal = withLazyFallback(() => import('components/Patient'));
const PatientDashboard = withLazyFallback(
  () => import('components/Patient/Dashboard/PatientDashboard')
);
const PatientMedicalRecords = withLazyFallback(() => import('components/Patient/MedicalRecords'));
const PatientTreatmentPlans = withLazyFallback(
  () => import('components/Patient/TreatmentPlans/PatientTreatmentPlans')
);
const AccountContainer = withLazyFallback(
  () => import('components/Patient/account/indexContainer')
);
const PatientAppointments = withLazyFallback(
  () => import('components/Patient/appointments/PatientDashboardAppointments')
);
const PatientDocumentsForPractice = withLazyFallback(
  () => import('components/Patient/documents/DocumentsForPractice')
);
const PatientDocuments = withLazyFallback(
  () => import('components/Patient/documents/PatientDocuments')
);
const PatientForms = withLazyFallback(() => import('components/Patient/forms/PatientForms'));
const PatientConversation = withLazyFallback(
  () => import('components/Patient/inbox/PatientConversation')
);
const PatientInbox = withLazyFallback(() => import('components/Patient/inbox/inbox'));
const PatientMedications = withLazyFallback(() => import('components/Patient/medications'));
const PatientPayments = withLazyFallback(() => import('components/Patient/billing/payments'));
const PatientQuestionnaires = withLazyFallback(() => import('components/Patient/questionnaires'));
const PatientReferrals = withLazyFallback(() => import('components/Patient/referrals'));
const PatientRequests = withLazyFallback(
  () => import('components/Patient/requests/PatientRequests')
);
const PatientSuperbills = withLazyFallback(() => import('components/Patient/billing/superbills'));
const Orders = withLazyFallback(() => import('components/practice/PracticeIQueue/Orders/Orders'));
const PatientBilling = withLazyFallback(() => import('components/Patient/billing/PatientBilling'));
const PatientInvoices = withLazyFallback(
  () => import('components/Patient/billing/invoices/PatientInvoices')
);
const PatientQuotes = withLazyFallback(
  () => import('components/Patient/billing/Quotes/PatientQuotes')
);

const PATIENT_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="" />,
    children: [
      {
        path: 'myportal',
        element: <PatientPortal />,
        children: [
          { path: '', element: <PatientDashboard />, handle: { title: 'Dashboard' } },
          { path: 'inbox', element: <PatientInbox />, handle: { title: 'Inbox' } },
          {
            path: 'inbox/:myPortalPractice',
            element: <PatientConversation />,
            handle: { title: 'Inbox' }
          },
          {
            path: 'medical-records',
            element: <PatientMedicalRecords />,
            handle: { title: 'Medical Records' }
          },
          {
            path: 'treatment-plans',
            element: <PatientTreatmentPlans />,
            handle: { title: 'Treatment Plans' }
          },
          {
            path: 'appointments',
            element: <PatientAppointments />,
            handle: { title: 'Appointments' }
          },
          {
            path: 'billing',
            element: <PatientBilling />,
            handle: { title: 'Billing' },
            children: [
              { path: '', element: <PatientPayments />, handle: { title: 'Payments' } },
              { path: 'invoices', element: <PatientInvoices />, handle: { title: 'Invoices' } },
              {
                path: 'superbills',
                element: <PatientSuperbills />,
                handle: { title: 'Superbills' }
              },
              { path: 'quotes', element: <PatientQuotes />, handle: { title: 'Quotes' } }
            ]
          },
          {
            path: 'questionnaires',
            element: <PatientQuestionnaires />,
            handle: { title: 'Questionnaires' }
          },
          {
            path: 'medications',
            element: <PatientMedications />,
            handle: { title: 'Medications' }
          },
          { path: 'referrals', element: <PatientReferrals />, handle: { title: 'Referrals' } },
          { path: 'requests', element: <PatientRequests />, handle: { title: 'Requests' } },
          { path: 'documents', element: <PatientDocuments />, handle: { title: 'Documents' } },
          {
            path: 'documents/:myPortalPractice',
            element: <PatientDocumentsForPractice />,
            handle: { title: 'Documents' }
          },
          {
            path: 'documents/:myPortalPractice/:pathId',
            element: <PatientDocumentsForPractice />,
            handle: { title: 'Documents' }
          },
          { path: 'account', element: <AccountContainer />, handle: { title: 'My Account' } },
          { path: 'forms', element: <PatientForms />, handle: { title: 'Forms' } },
          { path: 'orders', element: <Orders fromPatient />, handle: { title: 'Orders' } },
          { path: '*', element: <NotFound portal="myportal" /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PATIENT_DASHBOARD;
